<section class="content head">
  <iaud-audit-nav-bar class="audit-list__nav-bar" *ngIf="!findingId && !sidId"></iaud-audit-nav-bar>
  <div class="content-wrapper capa-list">
    <h1 class="capa-list__header" *ngIf="findingId || sidId">CAPA List</h1>
    <h1 class="capa-list__header" *ngIf="!findingId && !sidId">All CAPA List</h1>
    <div class="capa-list__buttons">
      <button mat-raised-button class="right-margin" [color]="'accent'" routerLink="capa/add" *ngIf="canAdd">+ Add CAPA</button>
    </div>

    <mat-card class="capa-list__panel" *ngIf="!hasInitialCapas">
      <div class="capa-list__no-capas">
        <div class="capa-list__no-capas--icon">
          +
        </div>
        <div class="capa-list__no-capas--text">
          <h1>No CAPAs</h1>
          <p>There are no CAPAs</p>
          <p>Please add new CAPA</p>
        </div>
        <button mat-raised-button class="capa-list__no-capas--add-button" [color]="'accent'" routerLink="capa/add">
          + Add CAPA
        </button>
      </div>
    </mat-card>
  </div>
</section>

<section class="content" *ngIf="hasInitialCapas">
  <div class="content-wrapper">
    <iaud-table 
        [data]="capaTableData" 
        [options]="capaTableOptions" 
        [forceReloadEvent]="forceReloadEvent"
        [dataRefreshCallback]="reloadCapaList.bind(this)" 
        [dataEditCallback]="capaDetailClick.bind(this)"
        [dataDeleteCallback]="deleteData.bind(this)" 
        [deleteTitle]="'Delete CAPA'"
        [deleteText]="'Are you sure you want to delete ${data.capaTitle} CAPA?'">
    </iaud-table>
  </div>
</section>

<ng-template #evidenceRights let-detailData="detailData" let-detailOption="detailOption">
  <label [for]="detailOption.fieldName">{{detailOption.title}}</label>
  <p [id]="detailOption.fieldName" *ngIf="detailData.item[detailOption.fieldName]">All CAPA/EC PICs required to submit</p>
  <p [id]="detailOption.fieldName" *ngIf="!detailData.item[detailOption.fieldName]">Only one of CAPA/EC PICs required to submit</p>
</ng-template>

<ng-template #statusCellTemplate let-rowData="rowData">
  <iaud-audit-capa-status [status]="rowData.status"></iaud-audit-capa-status>
</ng-template>

<ng-template #picsDetailTemplate let-detailData="detailData" let-detailOption="detailOption">
  <label [for]="detailOption.fieldName">{{detailOption.title}}</label>
  <p [id]="detailOption.fieldName" *ngFor="let pic of detailData.item[detailOption.fieldName]">
    {{ pic.fullName }}
  </p>
</ng-template>